<template>
  <div
    class="tab-box"
    :class="setSelectedTabBorderLine(index)"
    @click="changeSelectTabIndex(index)"
  >
    <input
      type="text"
      :value="tabItem.label"
      readonly="readonly"
      maxlength="9"
      :disabled="selectedTabIndex === index"
    />
  </div>
</template>

<script>
/**
 * 一つのタブを描画するコンポーネント
 * @Parent M.TabForm
 * @props tabItem: Object 一つのタブの情報
 * @props index: Number タブごとの要素番号
 * @props selectedTabIndex: Number 選択されているタブのインデックス番号
 * @props changeSelectTabIndex: Function タブインデックス情報を更新する関数
 */
export default {
  name: "A.TabItem",
  props: {
    tabItem: {
      type: Object,
    },
    index: {
      type: Number,
      required: true,
    },
    selectedTabIndex: {
      type: Number,
      required: true,
    },
    changeSelectTabIndex: {
      type: Function,
      required: true,
    },
  },
  methods: {
    setSelectedTabBorderLine(index) {
      return {
        selected: this.selectedTabIndex === index,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.tab-box {
  display: flex;

  input {
    font-family: $aisea-font-family;
    width: 100%;
    text-align: center;
    color: $aisea-pure-white;
    border: none;
    outline: none;
    background: none;
    opacity: 0.4;
    font-weight: bold;
    cursor: pointer;
  }

  &:hover {
    background-color: #595d69;
  }

  &:active {
    background-color: #8b8e97;
  }
}

.tab-box.selected {
  border-bottom: $aisea-blue solid 2px;
  input {
    opacity: 1;
    cursor: text;
  }
}
</style>
